import { DataEntryStateEnum } from '@osos/shared/types';

export function buildEntriesStatusFilter(status: {
  state: DataEntryStateEnum;
  includeValid: boolean;
  includeObsolete: boolean;
  includeInvalidRequirement: boolean;
}) {
  const { state, includeValid, includeObsolete, includeInvalidRequirement } =
    status;
  const or: any[] = [];
  if (!includeValid || !includeObsolete || !includeInvalidRequirement) {
    if (includeValid || (includeObsolete && includeInvalidRequirement)) {
      or.push({ isInvalid: !includeValid });
    }
    if (includeObsolete !== includeInvalidRequirement) {
      or.push({ invalidReason: includeObsolete ? 0 : 1 });
    }
  }

  return {
    state: state ?? undefined,
    or: or.length ? or : undefined,
  };
}
